import { render, staticRenderFns } from "./news17.vue?vue&type=template&id=640b7d9c&scoped=true&"
import script from "./news17.vue?vue&type=script&lang=js&"
export * from "./news17.vue?vue&type=script&lang=js&"
import style0 from "./news17.vue?vue&type=style&index=0&id=640b7d9c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640b7d9c",
  null
  
)

export default component.exports